export default __webpack_public_path__ + "static/media/STRETCH_PUFF_V.f32d6248.png";